import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './button.module.scss';

const cx = classnames.bind(styles);

function ButtonContainer({ children, fixed, hidden, className }) {
  const css = cx({ container: true, fixed, hidden });
  return <div className={`${css} ${className}`}>{children}</div>;
}

ButtonContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fixed: PropTypes.bool,
  hidden: PropTypes.bool,
};

ButtonContainer.defaultProps = {
  fixed: false,
  className: '',
  hidden: false,
};

export default ButtonContainer;
